<template>
    <div class="panel panel-info" v-if="place">
        <!-- Default panel contents -->
        <div class="panel-heading"><i class="fa fa-terminal" aria-hidden="true"></i> LAT & LONG</div>
        <div class="panel-body">
            <div class="form-group" v-if="! readonly">
                <div class="col-sm-8">
                    <label for="la2" class="control-label right">LATITUDE, LONGITUDE:</label><br/>
                    <input type="text" v-model="ll" class="form-control" id="la2">
                </div>

                <div class="col-sm-4">
                    <label for="inputUsuario" class="control-label">&nbsp;</label><br/>
                    <button @click="setJoinedMarker()" type="button" class="btn btn-info btn-block">
                        <i class="fa fa-map-marker" aria-hidden="true"></i> VER NO MAPA
                    </button>
                </div>
            </div>

            <hr v-if="! readonly"/>

            <div class="form-group" v-if="! readonly">
                <div class="col-sm-4">
                    <label for="inputIp" class="control-label right">LATITUDE:</label><br/>
                    <input type="text" v-model="place[1]" class="form-control" id="inputIp">
                </div>

                <div class="col-sm-4">
                    <label for="inputUsuario" class="control-label">LONGITUDE:</label><br/>
                    <input type="text" v-model="place[0]" class="form-control" id="inputUsuario">
                </div>

                <div class="col-sm-4">
                    <label for="inputUsuario" class="control-label">&nbsp;</label><br/>
                    <button @click="setMarker()" type="button" class="btn btn-info btn-block">
                        <i class="fa fa-map-marker" aria-hidden="true"></i> VER NO MAPA
                    </button>
                </div>
            </div>

            <div id="mapPlace" :style="'height: ' + height"></div>
        </div>
    </div>
</template>
<script>
/* global L */
export default {
    props: {
        place: {
            default: [0, 0]
        },
        height: {
            default: "300px"
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            ATTR:
                '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            CDB_URL:
                "https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
            map: null,
            ll: null,
            marker: null
        };
    },
    beforeDestroy() {
        this.map.off();
        this.map.remove();
        this.marker.remove();
        console.log("geocode off");
    },
    mounted() {
        this.map = L.map("mapPlace", {
            fullscreenControl: {
                pseudoFullscreen: false
            }
        });
        L.tileLayer(this.CDB_URL, { attribution: this.ATTR }).addTo(this.map);
        setTimeout(() => this.setMarker(), 200);
    },
    methods: {
        moved(e) {
            this.$emit("update:place", [
                e.target._latlng.lng,
                e.target._latlng.lat
            ]);
        },
        setMarker() {
            if (!this.marker) {
                this.marker = L.marker(
                    [
                        this.place[1] || -21.80149347,
                        this.place[0] || -41.305208
                    ],
                    {
                        draggable: true
                    }
                );
                this.marker.on("dragend", e => this.moved(e));
                this.marker.addTo(this.map);
            }
            this.marker = this.marker.setLatLng(
                L.latLng(
                    this.place[1] || -21.80149347,
                    this.place[0] || -41.305208
                )
            );
            this.map.setView(
                [this.place[1] || -21.80149347, this.place[0] || -41.305208],
                15
            );
        },
        setJoinedMarker() {
            let aux = this.ll.split(",");
            this.place[1] = aux[0];
            this.place[0] = aux[1];
            this.setMarker();
        }
    }
};
</script>
